import {classNames, createTheme} from "@variocube/cube-ui";
import {stylesheet} from "typestyle";
import {ShopType} from "./types";
import background from "./background.svg";

export const COLOR_PRIMARY = "#039BE5";

export const baseTheme = createTheme({
    colorBackground: "#f6f6f6",
    colorForeground: "#333",
    colorPrimary: COLOR_PRIMARY,
    colorSeparator: "#8fb0bf",
    colorInputBackground: "#fff",
});

export const dryCleaningTheme = createTheme({
    colorBackground: "#DFF4FE",
    colorForeground: "#303b40",
    colorPrimary: COLOR_PRIMARY,
    colorSeparator: "#8fb0bf",
    colorInputBackground: "#fff",
});

export const backgroundGradient = "radial-gradient(#fff, transparent), linear-gradient(#f0f0f0, #e0e0e0)";
export const boxShadow = "0 0 0.5rem -0.25rem rgba(0, 0, 0, 0.5)";

export function getTheme(shopType?: ShopType) {
    if (shopType === ShopType.DryCleaning) {
        return classNames(dryCleaningTheme, backgrounds.dryCleaning);
    }
    else {
        return classNames(baseTheme, backgrounds.generic);
    }
}

export const backgrounds = stylesheet({
    generic: {
        background: backgroundGradient,
    },
    dryCleaning: {
        background: `#DFF4FE url("${background}") no-repeat center / 100%`,
    }
})

export const grid = stylesheet({
    container: {
        padding: "0.75em",
    },
    item: {
        margin: "0.75em",
    },
    nested: {
        margin: "-1.5em"
    }
});